import React from 'react';
import PropTypes from 'prop-types';

// @ts-ignore
import Stepper from "src/core/gd-components/stepper/stepper";

export default class DecimalPlacesSelector extends React.Component<any> {
    static propTypes = {
        form: PropTypes.object.isRequired,
        name: PropTypes.string.isRequired,
        minValue: PropTypes.number,
        maxValue: PropTypes.number,
    }

    UNSAFE_componentWillMount() {
        this.props.form.registerFormComponent(this.props.name,this);
    }

    onChange = (newValue:any) => {
        this.props.form.onFormComponentValueChange(this.props.name,newValue);
    }

    render() {
        const value = this.props.form.getValue(this.props.name);

        return <Stepper className={this.props.className}
                        type="ui5"
                        value={value ? value : 0}
                        minValue={this.props.minValue}
                        maxValue={this.props.maxValue}
                        onChange={this.onChange}/>;
    }
}